define(['jquery', 'c21/maps/Page'], function ($, Page) {
   'use strict';

   var m_bInitialized = false,
      m_aOnInitialize,
      m_page;

   function triggerPageReady (page) {
      m_bInitialized = true;
      $.each(m_aOnInitialize, function (i, fn) {
         fn(page);
      });
   }

   function onReady (fn) {
      if (m_bInitialized) {
         fn(m_page);
      } else {
         m_aOnInitialize.push(fn);
      }
   }

   function initialize () {
      $("#bodyMain").on("beforePortalAjaxLoad.persist", function () {
         // Setup the page to re-initialize
         m_aOnInitialize = undefined;
         m_bInitialized = false;
         m_page = undefined;
      });
   }

   initialize();

   return {
      reset: function () {
         if (!m_bInitialized) {
            m_aOnInitialize = [];
            m_page = new Page(onReady, triggerPageReady);
            m_page.initialize();
         }
      },

      onReady: onReady
   };
});
